import React, { useState, useCallback, useEffect } from "react";
import Heading from "../../../../common/element/Heading";
import Segment from "../../../../common/element/Segment";
import Table from "../../../../common/element/Table";
import Badge from "../../../../common/element/Badge";
import Tag from "../../../../common/element/Tag";
import Scrollbar from "../../../../common/element/ScrollBar";
import BtnLight from "../../../../common/element/Buttons/btnLight";
import { useDispatch } from "react-redux";
import { setBreadcrumbs } from "../../../../redux/classes/breadcrumbsSlice";
import Tasks from "./Tasks";
import Inductions from "./Inductions";
import Documents from "./Documents";
import { useNavigate } from "react-router-dom";
import { GetUserOrganisationsList } from "../../../../actions/worker-portal/GetUserOrganisationsList";
import useUnauthorizedHandler from "../../../../common/snippet/useUnauthorizedHandler";
import CollapsiblePanel from "../../../../common/element/CollapsiblePanel";

const Dashboard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [workerDetail, setWorkerDetail] = useState();
  const [organisationDetail, setOrganisationDetail] = useState();
  const handleUnauthorizedAccess = useUnauthorizedHandler();
  const [isCollapsed, setIsCollapsed] = useState(false);

  useEffect(() => {
    // Set breadcrumbs when the component mounts
    dispatch(
      setBreadcrumbs([{ label: "Dashboard", url: "/worker/dashboard" }])
    );
  }, []);

  useEffect(() => {
    dispatch(GetUserOrganisationsList()).then((response) => {
      if (response?.success) {

        const userDetails = response?.data?.getUserDetails
        const orgDetails = response?.data?.userOrgs[0]?.user_perm_fa?.org_data;
        setWorkerDetail(userDetails);
        setOrganisationDetail(orgDetails);
      } else if (response?.status === 401) {
        handleUnauthorizedAccess();
      }
    });
  }, []);
  const [singleSegmentValue, setSingleSegmentValue] = useState(["Index"]);

  const { Tr, Th, Td, THead, TBody } = Table;
  const onSingleSelectionSegmentChange = useCallback(
    (val) => {
      setSingleSegmentValue(val);
    },
    [setSingleSegmentValue]
  );

  function formatAbnNzbn(value) {
    if (!value) return "";

    // Remove all spaces
    const digits = value.replace(/\s+/g, '');

    // Check if it's a valid length (e.g., 11 digits for ABN)
    if (digits.length !== 11) return value;

    // Format: 2 3 3 3 (e.g., 30 601 871 400)
    return `${digits.slice(0, 2)} ${digits.slice(2, 5)} ${digits.slice(5, 8)} ${digits.slice(8)}`;
  }
  return (
    <React.Fragment>
      {/* <Heading className="mb-4">Dashboard</Heading> */}
      <div className="flex items-center mb-5">
        <div className="h-16 w-16 rounded-full overflow-hidden mr-5 avtar_img_round">
          <img
            src={
              //here i can set image
              !workerDetail?.avatar ? "/assets/img/avatars/thumb-8.jpg" : workerDetail?.avatar

            }
            alt=""
          />
        </div>
        <div className="flex flex-col">
          <div className="flex gap-6 items-center">
            <span className="text-gray-900  font-medium">
              <span className="text-gray-400 mr-1 font-semibold">ID:</span>  
              {(() => {
                const rawId =
                  workerDetail?.employee_id_v2 ||
                  workerDetail?.employee_v2_id ||
                  workerDetail?.linked_user?.organisation_id ||
                  workerDetail?.organisation_id ||
                  "";

                const normalized = String(rawId || "").trim();
                if (!normalized || normalized === "-") return "-";
                return `E-${normalized}`;
              })()}
            </span>
           {/* <span className="text-gray-900  font-medium">
              <span className="text-gray-400 mr-1 font-semibold">ABN:</span>
              {organisationDetail?.abn_nzbn ? formatAbnNzbn(organisationDetail?.abn_nzbn) : "-"}
            </span> */}
          </div>
          <Heading className="mb-2">{workerDetail?.first_name} {workerDetail?.last_name}</Heading>
          {/* <div className="flex gap-6 items-center">
                        <span
                          className={
                            providerDetails?.is_org_active
                              ? "badge bg-green-50 text-green-700 py-0.5 px-2 rounded-full font-medium"
                              : "badge bg-red-50 text-red-600 py-0.5 px-2 rounded-full font-medium"
                          }
                        >
                          <span
                            className={
                              providerDetails?.is_org_active
                                ? "badge-dot badge-inner mr-1 bg-green-700"
                                : "badge-dot badge-inner mr-1 bg-red-700"
                            }
                          ></span>
                          {providerDetails?.is_org_active ? "Active" : "Deactivated"}{" "}
                        </span>
                      </div> */}
        </div>
      </div>
      <div className="grid grid-container gap-8" style={{ gridTemplateColumns: isCollapsed ? "1fr auto" : undefined }}>
        <div className="flex gap-8 flex-col">
          <Tasks />
        </div>
        <CollapsiblePanel
          isCollapsed={isCollapsed}
          onToggle={() => setIsCollapsed(!isCollapsed)}
          title="Overview"
        >
          <Inductions />
          <div className="flex gap-8 flex-col">
            <Documents />
          </div>
        </CollapsiblePanel>
      </div>
    </React.Fragment>
  );
};

export default Dashboard;
